// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playerRow_playerRow__304cf {\n  display: flex;\n  align-items: center;\n  min-height: 32px;\n  cursor: pointer;\n}\n.playerRow_playerRow__304cf span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.playerRow_playerRow__304cf .playerRow_rank__MBi8G {\n  width: 2rem;\n  text-align: center;\n}\n.playerRow_playerRow__304cf .playerRow_avatar__xoBeq {\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n}\n\n.playerRow_offline__35KFO, .playerRow_online__32Ktm {\n  min-width: 10px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50px;\n  margin-right: 5px;\n}\n\n.playerRow_online__32Ktm {\n  background-color: var(--green);\n}", ""]);
// Exports
exports.locals = {
	"playerRow": "playerRow_playerRow__304cf",
	"rank": "playerRow_rank__MBi8G",
	"avatar": "playerRow_avatar__xoBeq",
	"offline": "playerRow_offline__35KFO",
	"online": "playerRow_online__32Ktm"
};
module.exports = exports;
